import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const CollapsibleSection = ({ title, children, defaultOpen = false }) => {
	const [isOpen, setIsOpen] = useState(defaultOpen);

	return (
		<div className="border rounded-md mb-4">
			<div
				className="flex justify-between items-center cursor-pointer p-3 bg-gray-100 hover:bg-gray-200"
				onClick={() => setIsOpen(!isOpen)}
			>
				<h5 className="mb-0 font-medium">{title}</h5>
				{isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
			</div>
			{isOpen && <div className="p-4">{children}</div>}
		</div>
	);
};

export default CollapsibleSection;
